import * as React from 'react'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import { IApiConsumerArray } from '../../data/actions.interface'
import { IReport } from '../../data/admin/customer.interface'
import { getCustomerReports } from '../../data/admin/customer.actions'
import OTable, { ITableColumn } from '../../components/organisms/OTable'
import AButton from '../../components/atoms/AButton'
import APageRow from '../../components/atoms/APageRow'

interface IReportView extends IApiConsumer {
    customerId?: string
    reports: IApiConsumerArray<IReport>
}

const customerUserColumns = (onDelete: (row: IReport) => string, onModify: (row: IReport) => string): Array<ITableColumn<IReport>> => [
   
    {
        key: 'name',
        title: 'Name',
    },
    {
        key: 'url',
        title: 'Report',
    },
    {
        key: 'modify',
        render: row => (
            <AButton color="warning" outline to={onModify(row)}>
                Modify report
            </AButton>
        ),
    },
    {
        key: 'delete',
        render: row => (
            <AButton color="warning" outline to={onDelete(row)}>
                Delete report
            </AButton>
        ),
    }
]

class ReportView extends React.Component<IReportView> {
    onModify = (row: IReport) =>
                `${this.props.customerId}/customer-reports/${row.id}/modify`
    
    onDelete = (row: IReport) =>

                `${this.props.customerId}/customer-reports/${row.id}/${row.name}/delete`
    render() {
        const { reports , customerId} = this.props

        return (
            <React.Fragment>
                <APageRow
                    title="Manage Reports"
                    buttons={[
                        <AButton
                            key="create"
                            outline
                            to={`${customerId}/customer-reports/create`}
                            color="primary"
                        >
                            Add Report
                        </AButton>, 
                    ]}
                ></APageRow>
                <OTable rowKey={'id'} data={reports.response} columns={customerUserColumns( this.onDelete, this.onModify)} />
            </React.Fragment>
        )
    }
}

export default apiConsumer({
    reports: props => getCustomerReports(props.customerId),
})(ReportView)
